<template>
  <form class="auth-form" @submit.prevent="$emit('submit')">
    <div class="auth-form__head">
      <div class="auth-form__badge">Вход</div>
      <h2>С возвращением</h2>
      <p>Войди по номеру телефона и продолжай играть без лишних шагов.</p>
    </div>

    <div class="stack-md">
      <BaseInput
        :model-value="model.phone"
        type="tel"
        label="Телефон"
        placeholder="+7 917 131 57 89"
        required
        autocomplete="tel"
        inputmode="tel"
        maxlength="16"
        @update:modelValue="updatePhone"
      />
      <BaseInput
        v-model="model.password"
        type="password"
        label="Пароль"
        placeholder="••••••••"
        required
        autocomplete="current-password"
      />
    </div>

    <p v-if="error" class="message message--error">{{ error }}</p>
    <div class="auth-submit">
      <BaseButton block :loading="loading" type="submit">Войти</BaseButton>
    </div>
  </form>
</template>

<script>
import BaseButton from '../ui/BaseButton.vue';
import BaseInput from '../ui/BaseInput.vue';
import { formatRuPhone } from '../../utils/ruPhone';

export default {
  name: 'LoginForm',
  components: { BaseButton, BaseInput },
  props: {
    modelValue: {
      type: Object,
      required: true,
    },
    loading: Boolean,
    error: String,
  },
  emits: ['update:modelValue', 'submit'],
  computed: {
    model: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    },
  },
  methods: {
    updatePhone(value) {
      this.$emit('update:modelValue', {
        ...this.modelValue,
        phone: formatRuPhone(value),
      });
    },
  },
};
</script>

<style scoped>
.auth-form__head {
  margin-bottom: 24px;
}

.auth-form__badge {
  display: inline-flex;
  align-items: center;
  min-height: 28px;
  padding: 0 12px;
  border-radius: 999px;
  background: rgba(143, 107, 255, 0.16);
  color: #ceb6ff;
  font-size: 12px;
  font-weight: 800;
  text-transform: uppercase;
}

h2 {
  margin: 16px 0 8px;
  font-size: clamp(28px, 4vw, 36px);
}

p {
  margin: 0;
  color: var(--text-soft);
  line-height: 1.65;
}

.message {
  margin: 16px 0 0;
  padding: 14px 16px;
  border-radius: 16px;
}

.message--error {
  background: rgba(255, 90, 103, 0.12);
  color: #ffb2b8;
  border: 1px solid rgba(255, 90, 103, 0.18);
}

.auth-submit {
  margin-top: 24px;
}
</style>